function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { loyaltyApiRoutes } from '../api/v1/loyalty/routes';
import { OcapiHeader } from '../types/ocapi-header';
import { getCorrelationId } from './get-correlation-id';
/**
 * Gets the [[HttpRequestConfiguration]] for a particular API request, including request-specific headers.
 *
 * Merges the provided [[OcapiClientConfig]] and [[HttpRequestConfiguration]].
 */ export const getRequestConfig = async (url, config, requestConfig)=>{
    const headers = new Headers(requestConfig == null ? void 0 : requestConfig.headers);
    const authToken = await config.authTokenProvider();
    headers.append(OcapiHeader.Authorization, `Bearer ${authToken}`);
    // Append the loyalty authorization header if the `loyaltyAuthTokenProvider` is configured.
    // Exclude the `createToken` route to avoid an infinite loop.
    if (url !== loyaltyApiRoutes.members.authentication.createToken()) {
        const loyaltyAuthToken = await (config.loyaltyAuthTokenProvider == null ? void 0 : config.loyaltyAuthTokenProvider());
        if (loyaltyAuthToken) headers.append(OcapiHeader.LoyaltyAuthorization, loyaltyAuthToken.access_token);
    }
    // Each request get a unique correlation ID so that it can be traced throughout the API stack.
    headers.append(OcapiHeader.CorrelationId, getCorrelationId(config, authToken));
    return _extends({}, requestConfig, {
        headers
    });
};

//# sourceMappingURL=get-request-config.js.map